module.exports = __webpack_public_path__ + "img/small-19.b045ee49.jpg";